export default __webpack_public_path__ + "static/climate-change-banner-25c2479836f45ae9e552acc27c5453ed.png";